import { uniqueId } from "lodash";
import { getCascadingLabelById } from "./cascadingFieldHelpers";

const formatSavedSubForm = (
  subForm,
  siteSetPath,
  setShouldAskLocationAccess,
) => {
  const newSubForm = subForm.map((subForm, formIndex) => ({
    formIndex,
    index: subForm.index,
    name: subForm.name,
    role: subForm.role,
    isLocked: subForm.locked,
    fields: subForm.controls
      .filter((control) => control.field_code)
      .map((control, fieldIndex) => {
        const field = {
          fieldIndex,
          field_code: control.field_code,
          isRepeatable: control.field_type === "repeatableGroup",
        };

        if (control.field_type === "repeatableGroup") {
          if (control?.field_list && control?.field_list?.length > 0) {
            field.fields = [
              ...control.field_list?.map((repeatedField) => {
                return repeatedField
                  .filter((repeated) => repeated.field_code)
                  .map((repeated) => {
                    if (repeated?.field_type === "gps") {
                      setShouldAskLocationAccess(true);
                    } else if (repeated?.field_type === "selection") {
                      repeated.values = repeated.values.filter(
                        (value, index, self) =>
                          index === self.findIndex((v) => v === value),
                      );
                    }

                    const repeatable = control.controls.find(
                      (c) => c.field_code === repeated.field_code,
                    );

                    if (repeated?.field_attach) {
                      repeatable.field_attach = formatFieldAttach(
                        repeated.field_attach,
                      );
                    } else {
                      repeatable.field_attach = {
                        image_obj: null,
                        note: "",
                        original_forms: [],
                      };
                    }

                    return {
                      ...repeatable,
                      value: formatField(
                        { ...repeatable, ...repeated },
                        siteSetPath,
                      ),
                    };
                  });
              }),
            ];
          } else {
            field.fields = [
              control.controls
                .filter((c) => c.field_code)
                .map((c) => ({
                  ...c,
                  value: formatField(c, siteSetPath),
                  field_attach: {
                    image_obj: null,
                    note: "",
                    original_forms: [],
                  },
                })),
            ];
          }

          return field;
        }

        if (control?.field_type === "gps") {
          setShouldAskLocationAccess(true);
        } else if (control?.field_type === "selection") {
          control.values = control.values.filter(
            (value, index, self) => index === self.findIndex((v) => v === value),
          );
        }

        const fields = {
          ...control,
          fieldIndex,
          value: formatField(control, siteSetPath),
        };

        if (control?.field_attach) {
          fields.field_attach = formatFieldAttach(control.field_attach);
        } else {
          fields.field_attach = {
            image_obj: null,
            note: "",
            original_forms: [],
          };
        }

        return fields;
      }),
  }));

  return newSubForm;
};

const formatFieldAttach = (fieldAttach) => {
  return {
    image_obj: fieldAttach?.image_obj,
    note: fieldAttach?.note,
    original_forms: fieldAttach?.forms?.map((form) => ({
      ...form,
      original_id: form.id,
    })),
  };
};

const formatField = (field, siteSetPath) => {
  if (field.field_type === "signature") {
    return {
      obj: field.field_obj?.file_path,
      name: field.field_obj?.name,
    };
  }

  if (field.field_type === "image/photo") {
    if (field.type === "single" && field.field_obj?.file_path) {
      return [
        {
          url: field.field_obj.file_path,
          date: field.field_obj.created_at,
          author: field.field_obj.created_name,
          authorId: field.field_obj.created_by,
          zone: siteSetPath,
          id: uniqueId("form-photo-"),
        },
      ];
    } else if (field.type === "multiple" && field.field_obj_list?.length) {
      return field?.field_obj_list?.map((item) => ({
        url: item.file_path,
        date: item.created_at,
        author: item.created_name,
        authorId: item.created_by,
        zone: siteSetPath,
        id: uniqueId("form-photo-"),
      }));
    } else {
      return [];
    }
  }

  if (field.field_type === "selection") {
    if (field.type === "multi_selection") {
      if (field.data_source === "from_cascading_set") {
        return field.field_values?.map((valueId) => {
          const label = getCascadingLabelById(field, valueId);
          return { value: valueId, label: label };
        }) || [];
      } else {
        return field.field_values?.map((item) => ({ value: item, label: item })) || [];
      }
    } else {
      if (field.data_source === "from_cascading_set") {
        if (field.field_value) {
          const label = getCascadingLabelById(field, field.field_value);
          return { value: field.field_value, label: label };
        }
        return "";
      } else {
        if (field.field_value) {
          return { value: field.field_value, label: field.field_value };
        }
        return "";
      }
    }
  }

  if (field.field_value) {
    return field.field_value;
  } else if (field.field_obj && Object.keys(field.field_obj).length > 0) {
    return field.field_obj;
  } else if (field.field_values?.length > 0) {
    return field.field_values;
  } else if (field.min_value) {
    return field.min_value;
  } else {
    return "";
  }
};

export default formatSavedSubForm;